{
    "policy": {
        "policyId": 1026710523,
        "uqPolicyId": 1068422824,
        "policyNumber": "7050002306",
        "productName": "CASCOG - CASCO - skupinov\u00e9 poistenie",
        "statusId": 4,
        "status": "akt\u00edvna",
        "productNameSpecific": "PS01",
        "paidToDate": "2021-05-04T00:00:00.000+02:00",
        "leasFleetFlag": false,
        "packageId": 3004,
        "greenBoxPolicy": false,
        "lineOfBusiness": "CA - Havarijn\u00e9 poistenie",
        "paymentFrequency": "mesa\u010dne",
        "paymentMethod": "skupinov\u00e1 platba",
        "type": "dlhodob\u00e1 na dobu neur\u010dit\u00fa",
        "lineOfBusinessId": 3,
        "beginDate": "2014-01-01T00:00:00.000+01:00",
        "endDate": null,
        "paymentMethodId": 10,
        "paymentFrequencyId": 5,
        "effectiveFromDate": "2025-04-01T00:00:00.000+02:00",
        "effectiveEndDate": null,
        "typeId": 2,
        "premiumAmount": 455.52,
        "premiumCurrency": "EUR",
        "premiumMaturityDate": "2021-07-29T00:00:00.000+02:00",
        "premiumStatus": "overdue",
        "annualPremium": null,
        "termPremium": null,
        "detailTypeIdentifier": "CAR-INSURANCE",
        "crn": null,
        "model": null,
        "dateBeginOrig": null,
        "paymentBlockageFlag": false,
        "annualPaidPremium": null,
        "bankAccount": [
            {
                "account": "SK7011000000002625002865",
                "policyHolderInDescr": 0,
                "policyHolderAccount": 1,
                "bankDescript": "VOLKSWAGEN Finan\u010dn\u00e9 slu\u017eby,"
            }
        ],
        "firstInsuredName": null,
        "gatewayPaymentUrl": "https:\/\/online.allianz.sk\/platobna-brana\/ZTAyYTBmZDE0ZDI0Y2I0Y2Y1Mzc3NzVlNDc0MzgwZjlfNzA1MDAwMjMwNl80NTUuNTJfM19fQ1BfZWtwdGVzdDIyMEBhbGxpYW56LnNr"
    },
    "premiumList": {
        "list": []
    },
    "maInsurance": {
        "detailTypeIdentifier": "CAR-INSURANCE",
        "vehicle": {
            "variant": null,
            "brand": null,
            "model": null,
            "category": null
        },
        "risks": []
    }
}